var map = {
	"./arrow.png": "./resources/assets/images/arrow.png",
	"./arrow_next.svg": "./resources/assets/images/arrow_next.svg",
	"./arrow_previous.svg": "./resources/assets/images/arrow_previous.svg",
	"./circle.svg": "./resources/assets/images/circle.svg",
	"./cross.svg": "./resources/assets/images/cross.svg",
	"./datepicker.svg": "./resources/assets/images/datepicker.svg",
	"./dot-grid.svg": "./resources/assets/images/dot-grid.svg",
	"./emerge.svg": "./resources/assets/images/emerge.svg",
	"./icons/android-chrome-192x192.png": "./resources/assets/images/icons/android-chrome-192x192.png",
	"./icons/android-chrome-512x512.png": "./resources/assets/images/icons/android-chrome-512x512.png",
	"./icons/apple-touch-icon.png": "./resources/assets/images/icons/apple-touch-icon.png",
	"./icons/favicon-16x16.png": "./resources/assets/images/icons/favicon-16x16.png",
	"./icons/favicon-32x32.png": "./resources/assets/images/icons/favicon-32x32.png",
	"./icons/mstile-150x150.png": "./resources/assets/images/icons/mstile-150x150.png",
	"./icons/safari-pinned-tab.svg": "./resources/assets/images/icons/safari-pinned-tab.svg",
	"./logo-large.svg": "./resources/assets/images/logo-large.svg",
	"./multi-plus.svg": "./resources/assets/images/multi-plus.svg",
	"./plus-grid.svg": "./resources/assets/images/plus-grid.svg",
	"./plus.svg": "./resources/assets/images/plus.svg",
	"./ui-icons_222222_256x240.png": "./resources/assets/images/ui-icons_222222_256x240.png",
	"./ui-icons_454545_256x240.png": "./resources/assets/images/ui-icons_454545_256x240.png",
	"./ui-icons_888888_256x240.png": "./resources/assets/images/ui-icons_888888_256x240.png",
	"./ui-icons_cd0a0a_256x240.png": "./resources/assets/images/ui-icons_cd0a0a_256x240.png",
	"./wheel.svg": "./resources/assets/images/wheel.svg",
	"./wheel_bak.svg": "./resources/assets/images/wheel_bak.svg",
	"resources/assets/images/arrow.png": "./resources/assets/images/arrow.png",
	"resources/assets/images/arrow_next.svg": "./resources/assets/images/arrow_next.svg",
	"resources/assets/images/arrow_previous.svg": "./resources/assets/images/arrow_previous.svg",
	"resources/assets/images/circle.svg": "./resources/assets/images/circle.svg",
	"resources/assets/images/cross.svg": "./resources/assets/images/cross.svg",
	"resources/assets/images/datepicker.svg": "./resources/assets/images/datepicker.svg",
	"resources/assets/images/dot-grid.svg": "./resources/assets/images/dot-grid.svg",
	"resources/assets/images/emerge.svg": "./resources/assets/images/emerge.svg",
	"resources/assets/images/icons/android-chrome-192x192.png": "./resources/assets/images/icons/android-chrome-192x192.png",
	"resources/assets/images/icons/android-chrome-512x512.png": "./resources/assets/images/icons/android-chrome-512x512.png",
	"resources/assets/images/icons/apple-touch-icon.png": "./resources/assets/images/icons/apple-touch-icon.png",
	"resources/assets/images/icons/favicon-16x16.png": "./resources/assets/images/icons/favicon-16x16.png",
	"resources/assets/images/icons/favicon-32x32.png": "./resources/assets/images/icons/favicon-32x32.png",
	"resources/assets/images/icons/mstile-150x150.png": "./resources/assets/images/icons/mstile-150x150.png",
	"resources/assets/images/icons/safari-pinned-tab.svg": "./resources/assets/images/icons/safari-pinned-tab.svg",
	"resources/assets/images/logo-large.svg": "./resources/assets/images/logo-large.svg",
	"resources/assets/images/multi-plus.svg": "./resources/assets/images/multi-plus.svg",
	"resources/assets/images/plus-grid.svg": "./resources/assets/images/plus-grid.svg",
	"resources/assets/images/plus.svg": "./resources/assets/images/plus.svg",
	"resources/assets/images/ui-icons_222222_256x240.png": "./resources/assets/images/ui-icons_222222_256x240.png",
	"resources/assets/images/ui-icons_454545_256x240.png": "./resources/assets/images/ui-icons_454545_256x240.png",
	"resources/assets/images/ui-icons_888888_256x240.png": "./resources/assets/images/ui-icons_888888_256x240.png",
	"resources/assets/images/ui-icons_cd0a0a_256x240.png": "./resources/assets/images/ui-icons_cd0a0a_256x240.png",
	"resources/assets/images/wheel.svg": "./resources/assets/images/wheel.svg",
	"resources/assets/images/wheel_bak.svg": "./resources/assets/images/wheel_bak.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/assets/images sync recursive \\.(png%7Cjpe?g%7Cgif%7Csvg)$";